import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { bookingDetailsRow, COPY_DETAILS_COLUMNS } from "./copyDetails";

/* Copies the booking as one spreadsheet row (see copyDetails.js) so it can be
   pasted straight into the guest-house register. The button itself reports
   the outcome for a couple of seconds, like the per-field copy icons. */
export default function CopyDetailsButton({ booking, paymentLabel, guestHouses = [] }) {
  const [state, setState] = useState("idle"); // idle | copied | failed
  const ghShortById = useMemo(
    () => new Map(guestHouses.filter((g) => g.shortName).map((g) => [g.id, g.shortName])),
    [guestHouses],
  );
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const flash = (next) => {
    setState(next);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState("idle"), 2000);
  };

  const handleCopy = () => {
    const text = bookingDetailsRow(booking, { paymentLabel, ghShortById });
    if (!navigator.clipboard?.writeText) {
      flash("failed");
      return;
    }
    navigator.clipboard.writeText(text).then(
      () => flash("copied"),
      () => flash("failed"),
    );
  };

  return (
    <Button
      basic
      color={state === "failed" ? "red" : "blue"}
      size="small"
      type="button"
      onClick={handleCopy}
      title={`Copies one row for Excel: ${COPY_DETAILS_COLUMNS.join(", ")}`}
    >
      <Icon name={state === "copied" ? "check" : "clipboard outline"} />
      {state === "copied" ? "Copied!" : state === "failed" ? "Copy failed" : "Copy Details"}
    </Button>
  );
}
